import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pre-editing',
  templateUrl: './pre-editing.component.html',
  styleUrls: ['./pre-editing.component.scss']
})
export class PreEditingComponent implements OnInit {

  constructor(private _router: Router,) { }

  ngOnInit(): void {
  }

  goBackToDashboard()
  {
    // alert('welcome')
   window.close(); 
  //  window.location.href = 'dashboard.html';
   this._router.createUrlTree(['/dashboard'])
  }
}
